import { Component, OnDestroy, ViewChild, inject } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription } from 'rxjs';
import { EventsService } from 'src/app/private/events/services/events.service';
import {
  GsEventSelectorComponent,
  SelectionMeta,
} from 'src/app/shared/features/event-selector/gs-event-selector.component';
import { UtilsService } from 'src/app/private/services/utils.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { Upgrade } from '../../models/upgrade.model';
import { UpgradeService } from '../../services/upgrade.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css'],
  imports: [
    BoDialogComponent,
    ButtonComponent,
    FormsModule,
    GsEventSelectorComponent,
  ],
})
export class CreateComponent implements OnDestroy {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private upgradeService = inject(UpgradeService);
  utils = inject(UtilsService);
  eventService = inject(EventsService);

  @ViewChild(GsEventSelectorComponent)
  eventSelector: GsEventSelectorComponent;

  public item: Upgrade;

  public subscriptions: Array<Subscription>;
  public selectedEventIds: number[] = [];
  public isAllEventsSelected = false;
  public hashValidator = {
    name: false,
    description: false,
    goal: false,
    minSeatsToShow: false,
  };

  constructor() {
    this.item = {
      id: 0,
      active: true,
      name: '',
      description: '',
      minSeatsToShow: 1,
      goal: 1,
      events: [],
    };
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm() {
    if (this.checkInputs(this.item)) return;
    this.upgradeService
      .create$(this.item, this.selectedEventIds ?? [])
      .subscribe({
        next: response => {
          this.onDismiss('success');
        },
        error: err => {
          console.log(err);
        },
      });
  }

  public onEventSelectionChange(ids: number[]) {
    this.selectedEventIds = ids;
  }

  public onEventSelectionMeta(meta: SelectionMeta) {
    this.isAllEventsSelected = meta.isAllSelected;
  }

  public onSelectAllEventsChange(event: any) {
    this.eventSelector.selectAll(event.target.checked);
  }

  private checkInputs(instance: Upgrade): boolean {
    let hasErrors = false;
    Object.keys(this.hashValidator).forEach(value => {
      this.hashValidator[value] = false;
    });
    if (this.utils.isEmpty(instance.name)) {
      this.hashValidator.name = true;
      hasErrors = true;
    }
    if (this.utils.isEmpty(instance.description)) {
      this.hashValidator.description = true;
      hasErrors = true;
    }
    if (instance.minSeatsToShow < 0) {
      this.hashValidator.minSeatsToShow = true;
      hasErrors = true;
    }
    if (instance.goal < 0) {
      this.hashValidator.goal = true;
      hasErrors = true;
    }

    return hasErrors;
  }
}
